import * as React from "react";
import type { DateFilter } from "@/modules/snapshots/grid/sortAndFilter";

/** Date range filter state. `onDateFilterChange` runs synchronously so paging resets in the same batch. */
export const useSnapshotGridDateFilter = (onDateFilterChange: () => void) => {
  const [dateFilter, setDateFilter] = React.useState<DateFilter>({
    startDate: null,
    endDate: null,
    selectedField: null,
  });
  const [showDateFilterModal, setShowDateFilterModal] = React.useState(false);
  const [dateRangeTouched, setDateRangeTouched] = React.useState(false);

  const handleDateFilterChange = (startDate: Date | null, endDate: Date | null, selectedField?: string | null) => {
    onDateFilterChange();
    setDateRangeTouched(true);
    setDateFilter(prev => ({
      startDate,
      endDate,
      selectedField: selectedField !== undefined ? selectedField : prev.selectedField,
    }));
  };

  const handleDateFilterClear = () => {
    onDateFilterChange();
    setDateRangeTouched(true);
    setDateFilter({ startDate: null, endDate: null, selectedField: null });
  };

  return {
    dateFilter,
    setDateFilter,
    dateRangeTouched,
    showDateFilterModal,
    setShowDateFilterModal,
    handleDateFilterChange,
    handleDateFilterClear,
  };
};
